import { render, staticRenderFns } from "./SectorTreeList.vue?vue&type=template&id=227e3fae&scoped=true"
import script from "./SectorTreeList.vue?vue&type=script&lang=js"
export * from "./SectorTreeList.vue?vue&type=script&lang=js"
import style0 from "./SectorTreeList.vue?vue&type=style&index=0&id=227e3fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e3fae",
  null
  
)

export default component.exports